import { applyPermissionsFromMe, checkMenus } from 'shared/lib/authUtils';
import { getMe } from '../../api/get-me';

/**
 * Re-pull GET /me and rewrite the locally stored permissions (menus + company).
 *
 * Used by:
 *  - the login flow (usePostLoginSetup) as the single source of permissions, and
 *  - the refresh-token flow (refreshToken.js) to keep permissions current when
 *    the access token is refreshed mid-session.
 *
 * Errors propagate — the caller decides whether a /me failure is fatal
 * (login: fatal) or non-fatal (token refresh: keep prior permissions).
 *
 * @returns {Promise<Array>} the effective stored menus (incl. any super-admin
 *   static injection), so the caller can run the redirect-on-revoke check
 *   against the same data the router and route guards resolve.
 */
export async function refreshUserPermissions() {
  const me = await getMe();
  applyPermissionsFromMe(me?.data);
  return checkMenus() ?? [];
}
